(function(){
  if(window.cpTapZoom)return; window.cpTapZoom=true;
  document.addEventListener('click',function(e){
    if(e.defaultPrevented)return;
    var item=e.target.closest('.product__media-item'); if(!item)return;
    if(e.target.closest('button,a,.flickity-button,.deferred-media,video,model-viewer'))return;
    var t=item.querySelector('.product__media-toggle'); if(!t)return;
    t.click();
    var g=item.closest('ul'); if(g)g.classList.add('modal--open');
  });
})();
(function(){
  if(window.cpPinch)return; window.cpPinch=true;
  var st=null, lastTap=0, lastEl=null;
  function target(e){var t=e.target;return t&&t.closest?t.closest('product-modal img'):null;}
  function z(el){if(!el._cpz){el._cpz={el:el,s:1,x:0,y:0};el.style.transformOrigin='0 0';el.style.willChange='transform';}return el._cpz;}
  function draw(q,anim){q.el.style.transition=anim?'transform .25s ease':'none';q.el.style.transform='translate('+q.x+'px,'+q.y+'px) scale('+q.s+')';}
  function origin(q){var r=q.el.getBoundingClientRect();return {x:r.left-q.x,y:r.top-q.y};}
  function mid(a,b){return {x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2};}
  function dist(a,b){return Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);}
  function reset(q,anim){q.s=1;q.x=0;q.y=0;draw(q,anim);}
  function zoomAt(q,ns,px,py,anim){var o=origin(q);var cx=px-o.x,cy=py-o.y;q.x=cx-(cx-q.x)*(ns/q.s);q.y=cy-(cy-q.y)*(ns/q.s);q.s=ns;draw(q,anim);}
  document.addEventListener('touchstart',function(e){
    var el=target(e);if(!el)return;var q=z(el);
    if(e.touches.length===2){var m=mid(e.touches[0],e.touches[1]);var o=origin(q);
      st={mode:'pinch',q:q,d0:dist(e.touches[0],e.touches[1]),s0:q.s,x0:q.x,y0:q.y,cx:m.x-o.x,cy:m.y-o.y,o:o};e.preventDefault();return;}
    if(e.touches.length===1){var t=e.touches[0],now=Date.now();
      if(now-lastTap<300&&lastEl===el){lastTap=0;e.preventDefault();if(q.s>1.05)reset(q,true);else zoomAt(q,2.5,t.clientX,t.clientY,true);st=null;return;}
      lastTap=now;lastEl=el;
      if(q.s>1.05){st={mode:'pan',q:q,sx:t.clientX,sy:t.clientY,x0:q.x,y0:q.y};e.preventDefault();}}
  },{passive:false,capture:true});
  document.addEventListener('touchmove',function(e){
    if(!st)return;e.preventDefault();var q=st.q;
    if(st.mode==='pinch'&&e.touches.length>=2){var d=dist(e.touches[0],e.touches[1]);var ns=Math.max(1,Math.min(4,st.s0*d/st.d0));
      var m=mid(e.touches[0],e.touches[1]);var mx=m.x-st.o.x,my=m.y-st.o.y;
      q.x=mx-(st.cx-st.x0)*(ns/st.s0);q.y=my-(st.cy-st.y0)*(ns/st.s0);q.s=ns;draw(q,false);}
    else if(st.mode==='pan'&&e.touches.length===1){var t=e.touches[0];q.x=st.x0+(t.clientX-st.sx);q.y=st.y0+(t.clientY-st.sy);draw(q,false);}
  },{passive:false,capture:true});
  document.addEventListener('touchend',function(e){
    if(!st)return;var q=st.q;
    if(e.touches.length===1&&q.s>1.05){var t=e.touches[0];st={mode:'pan',q:q,sx:t.clientX,sy:t.clientY,x0:q.x,y0:q.y};return;}
    if(e.touches.length===0){if(q.s<=1.05)reset(q,true);st=null;}
  },{capture:true});
  function watch(){var pm=document.querySelector('product-modal');if(!pm)return;
    new MutationObserver(function(){if(!pm.hasAttribute('open')){pm.querySelectorAll('img').forEach(function(i){if(i._cpz)reset(i._cpz,false);});}}).observe(pm,{attributes:true,attributeFilter:['open']});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
})();